/**
 * Exporte einzelner Abstimmungen und ganzer Veranstaltungen (§27).
 *
 * Die Token-Ausgabe als CSV und die DIN-A6-Karten gehören ausdrücklich **nicht** hierher: sie
 * werden gestreamt und nie gespeichert, damit keine dauerhafte Datei einen vollständigen Token
 * trägt (Entscheidung E22 in `docs/ARCHITECTURE.md`).
 */
/** Die drei Formate einer einzelnen Abstimmung (§27.1). */
export const EXPORTFORMAT_WERTE = ['pdf', 'csv', 'json'];
export const EXPORTFORMAT_BESCHRIFTUNG = {
    pdf: 'PDF',
    csv: 'CSV',
    json: 'JSON',
};
/** Art eines verbuchten Exports. Bestimmt zugleich das Bezugsobjekt. */
export const EXPORTART_WERTE = [
    'abstimmung_pdf',
    'abstimmung_csv',
    'abstimmung_json',
    'veranstaltung_json',
    /** Gemeinsames PDF aller Ergebnisse einer Veranstaltung (§27.2, ÄA-6). */
    'veranstaltung_pdf',
];
export const EXPORTART_BESCHRIFTUNG = {
    abstimmung_pdf: 'Abstimmung als PDF',
    abstimmung_csv: 'Abstimmung als CSV',
    abstimmung_json: 'Abstimmung als JSON',
    veranstaltung_json: 'Veranstaltung als JSON',
    veranstaltung_pdf: 'Veranstaltung als PDF',
};
/** Die Exportart zu einem Format einer Abstimmung. */
export function abstimmungExportart(format) {
    return `abstimmung_${format}`;
}
//# sourceMappingURL=export.js.map